import {
  GET_COMMULATIVE_EARNING,
  GET_COMMULATIVE_EARNING_SUCCESS,
  GET_COMMULATIVE_EARNING_ERROR,
  GET_COMMULATIVE_EARNING_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCommulativeEarning = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMMULATIVE_EARNING:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_COMMULATIVE_EARNING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_COMMULATIVE_EARNING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_COMMULATIVE_EARNING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCommulativeEarning;
